import React from 'react';
import "./service.css";

const Service = (props) => {
    return ( 
        <>
            <div className="service">
                <img src={props.imgsrc} alt="/"/>
                <h2>{props.text}</h2>
                <p>{props.para}</p>
            </div>
        </>
     );
}
 
export default Service;